import {Injectable} from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {TRANSACTIONS_CONFIG} from "../../config/api";
import {LoaderService} from "../loader.service";

@Injectable({
    providedIn: 'root'
})
export class TransactionsService {
    private config = TRANSACTIONS_CONFIG;

    constructor(private http: HttpClient, public loaderService: LoaderService) {
    }

    confirmation(paymentIntent) {
        // return timer(2500).pipe();
        return this.http.post<any>(this.config.confirmation, {paymentIntent});
    }

    // onCloseProcessingPopup(val = null) {
    //     window.parent.postMessage(val, '*');
    // }
}
